/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppChatRouteRouteImport } from './routes/_app/chat/route'
import { Route as AppInsightsRouteRouteImport } from './routes/_app/insights/route'
import { Route as AppKitRouteImport } from './routes/_app/kit'
import { Route as AppKnowledgeRouteRouteImport } from './routes/_app/knowledge/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppStudioRouteRouteImport } from './routes/_app/studio/route'
import { Route as AppTasksRouteRouteImport } from './routes/_app/tasks/route'
import { Route as AppWorkplaceRouteRouteImport } from './routes/_app/workplace/route'
import { Route as AppChatIndexRouteImport } from './routes/_app/chat/index'
import { Route as AppChatSessionIdRouteImport } from './routes/_app/chat/$sessionId'
import { Route as AppChatHistoryRouteImport } from './routes/_app/chat/history'
import { Route as AppChatPlaygroundRouteImport } from './routes/_app/chat/playground'
import { Route as AppInsightsIndexRouteImport } from './routes/_app/insights/index'
import { Route as AppInsightsCostsRouteImport } from './routes/_app/insights/costs'
import { Route as AppInsightsMonitorRouteImport } from './routes/_app/insights/monitor'
import { Route as AppInsightsRunsRouteImport } from './routes/_app/insights/runs'
import { Route as AppKnowledgeIndexRouteImport } from './routes/_app/knowledge/index'
import { Route as AppKnowledgeSearchRouteImport } from './routes/_app/knowledge/search'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsApiTokensRouteImport } from './routes/_app/settings/api-tokens'
import { Route as AppSettingsAuditRouteImport } from './routes/_app/settings/audit'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings/members'
import { Route as AppSettingsOrganizationRouteImport } from './routes/_app/settings/organization'
import { Route as AppSettingsOrganizationsRouteImport } from './routes/_app/settings/organizations'
import { Route as AppSettingsPlatformUsersRouteImport } from './routes/_app/settings/platform-users'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppStudioIndexRouteImport } from './routes/_app/studio/index'
import { Route as AppStudioAgentsRouteImport } from './routes/_app/studio/agents'
import { Route as AppStudioAutomationsRouteImport } from './routes/_app/studio/automations'
import { Route as AppStudioBudgetsRouteImport } from './routes/_app/studio/budgets'
import { Route as AppStudioConnectorsRouteImport } from './routes/_app/studio/connectors'
import { Route as AppStudioEndpointsRouteImport } from './routes/_app/studio/endpoints'
import { Route as AppStudioIntegrationsRouteImport } from './routes/_app/studio/integrations'
import { Route as AppStudioMcpRouteImport } from './routes/_app/studio/mcp'
import { Route as AppStudioModelsRouteImport } from './routes/_app/studio/models'
import { Route as AppStudioProvidersRouteImport } from './routes/_app/studio/providers'
import { Route as AppStudioSchedulesRouteImport } from './routes/_app/studio/schedules'
import { Route as AppStudioSkillsRouteImport } from './routes/_app/studio/skills'
import { Route as AppStudioTeamsRouteImport } from './routes/_app/studio/teams'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks/index'
import { Route as AppTasksTaskIdRouteImport } from './routes/_app/tasks/$taskId'
import { Route as AppTasksBoardRouteImport } from './routes/_app/tasks/board'
import { Route as AppWorkplaceIndexRouteImport } from './routes/_app/workplace/index'
import { Route as AppWorkplaceRoomIdRouteImport } from './routes/_app/workplace/$roomId'
import { Route as AppInsightsRunsIndexRouteImport } from './routes/_app/insights/runs/index'
import { Route as AppInsightsRunsRunIdRouteImport } from './routes/_app/insights/runs/$runId'
import { Route as AppStudioAgentsIndexRouteImport } from './routes/_app/studio/agents/index'
import { Route as AppStudioAgentsAgentIdRouteImport } from './routes/_app/studio/agents/$agentId'
import { Route as AppStudioConnectorsIndexRouteImport } from './routes/_app/studio/connectors/index'
import { Route as AppStudioConnectorsConnectorIdRouteImport } from './routes/_app/studio/connectors/$connectorId'
import { Route as AppStudioEvalsIndexRouteImport } from './routes/_app/studio/evals/index'
import { Route as AppStudioEvalsSuiteIdRouteImport } from './routes/_app/studio/evals/$suiteId'
import { Route as AppStudioTeamsIndexRouteImport } from './routes/_app/studio/teams/index'
import { Route as AppStudioTeamsTeamIdRouteImport } from './routes/_app/studio/teams/$teamId'
import { Route as AppTasksProjectsIndexRouteImport } from './routes/_app/tasks/projects/index'
import { Route as AppTasksProjectsProjectIdRouteImport } from './routes/_app/tasks/projects/$projectId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRouteRoute = AppChatRouteRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRouteRoute = AppInsightsRouteRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppKitRoute = AppKitRouteImport.update({
  id: '/kit',
  path: '/kit',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeRouteRoute = AppKnowledgeRouteRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppStudioRouteRoute = AppStudioRouteRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRouteRoute = AppTasksRouteRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkplaceRouteRoute = AppWorkplaceRouteRouteImport.update({
  id: '/workplace',
  path: '/workplace',
  getParentRoute: () => AppRoute,
} as any)
const AppChatIndexRoute = AppChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatSessionIdRoute = AppChatSessionIdRouteImport.update({
  id: '/$sessionId',
  path: '/$sessionId',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatHistoryRoute = AppChatHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatPlaygroundRoute = AppChatPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppInsightsIndexRoute = AppInsightsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInsightsRouteRoute,
} as any)
const AppInsightsCostsRoute = AppInsightsCostsRouteImport.update({
  id: '/costs',
  path: '/costs',
  getParentRoute: () => AppInsightsRouteRoute,
} as any)
const AppInsightsMonitorRoute = AppInsightsMonitorRouteImport.update({
  id: '/monitor',
  path: '/monitor',
  getParentRoute: () => AppInsightsRouteRoute,
} as any)
const AppInsightsRunsRoute = AppInsightsRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => AppInsightsRouteRoute,
} as any)
const AppKnowledgeIndexRoute = AppKnowledgeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppKnowledgeRouteRoute,
} as any)
const AppKnowledgeSearchRoute = AppKnowledgeSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppKnowledgeRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsApiTokensRoute = AppSettingsApiTokensRouteImport.update({
  id: '/api-tokens',
  path: '/api-tokens',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAuditRoute = AppSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOrganizationRoute = AppSettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOrganizationsRoute =
  AppSettingsOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsPlatformUsersRoute =
  AppSettingsPlatformUsersRouteImport.update({
    id: '/platform-users',
    path: '/platform-users',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppStudioIndexRoute = AppStudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioAgentsRoute = AppStudioAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioAutomationsRoute = AppStudioAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioBudgetsRoute = AppStudioBudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioConnectorsRoute = AppStudioConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioEndpointsRoute = AppStudioEndpointsRouteImport.update({
  id: '/endpoints',
  path: '/endpoints',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioIntegrationsRoute = AppStudioIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioMcpRoute = AppStudioMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioModelsRoute = AppStudioModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioProvidersRoute = AppStudioProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioSchedulesRoute = AppStudioSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioSkillsRoute = AppStudioSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioTeamsRoute = AppStudioTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTasksRouteRoute,
} as any)
const AppTasksTaskIdRoute = AppTasksTaskIdRouteImport.update({
  id: '/$taskId',
  path: '/$taskId',
  getParentRoute: () => AppTasksRouteRoute,
} as any)
const AppTasksBoardRoute = AppTasksBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AppTasksRouteRoute,
} as any)
const AppWorkplaceIndexRoute = AppWorkplaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkplaceRouteRoute,
} as any)
const AppWorkplaceRoomIdRoute = AppWorkplaceRoomIdRouteImport.update({
  id: '/$roomId',
  path: '/$roomId',
  getParentRoute: () => AppWorkplaceRouteRoute,
} as any)
const AppInsightsRunsIndexRoute = AppInsightsRunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInsightsRunsRoute,
} as any)
const AppInsightsRunsRunIdRoute = AppInsightsRunsRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => AppInsightsRunsRoute,
} as any)
const AppStudioAgentsIndexRoute = AppStudioAgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStudioAgentsRoute,
} as any)
const AppStudioAgentsAgentIdRoute = AppStudioAgentsAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AppStudioAgentsRoute,
} as any)
const AppStudioConnectorsIndexRoute =
  AppStudioConnectorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStudioConnectorsRoute,
  } as any)
const AppStudioConnectorsConnectorIdRoute =
  AppStudioConnectorsConnectorIdRouteImport.update({
    id: '/$connectorId',
    path: '/$connectorId',
    getParentRoute: () => AppStudioConnectorsRoute,
  } as any)
const AppStudioEvalsIndexRoute = AppStudioEvalsIndexRouteImport.update({
  id: '/evals/',
  path: '/evals/',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioEvalsSuiteIdRoute = AppStudioEvalsSuiteIdRouteImport.update({
  id: '/evals/$suiteId',
  path: '/evals/$suiteId',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppStudioTeamsIndexRoute = AppStudioTeamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStudioTeamsRoute,
} as any)
const AppStudioTeamsTeamIdRoute = AppStudioTeamsTeamIdRouteImport.update({
  id: '/$teamId',
  path: '/$teamId',
  getParentRoute: () => AppStudioTeamsRoute,
} as any)
const AppTasksProjectsIndexRoute = AppTasksProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppTasksRouteRoute,
} as any)
const AppTasksProjectsProjectIdRoute =
  AppTasksProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AppTasksRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/chat': typeof AppChatRouteRouteWithChildren
  '/insights': typeof AppInsightsRouteRouteWithChildren
  '/knowledge': typeof AppKnowledgeRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/studio': typeof AppStudioRouteRouteWithChildren
  '/tasks': typeof AppTasksRouteRouteWithChildren
  '/workplace': typeof AppWorkplaceRouteRouteWithChildren
  '/kit': typeof AppKitRoute
  '/chat/$sessionId': typeof AppChatSessionIdRoute
  '/chat/history': typeof AppChatHistoryRoute
  '/chat/playground': typeof AppChatPlaygroundRoute
  '/insights/costs': typeof AppInsightsCostsRoute
  '/insights/monitor': typeof AppInsightsMonitorRoute
  '/insights/runs': typeof AppInsightsRunsRouteWithChildren
  '/knowledge/search': typeof AppKnowledgeSearchRoute
  '/settings/api-tokens': typeof AppSettingsApiTokensRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/organization': typeof AppSettingsOrganizationRoute
  '/settings/organizations': typeof AppSettingsOrganizationsRoute
  '/settings/platform-users': typeof AppSettingsPlatformUsersRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/studio/agents': typeof AppStudioAgentsRouteWithChildren
  '/studio/automations': typeof AppStudioAutomationsRoute
  '/studio/budgets': typeof AppStudioBudgetsRoute
  '/studio/connectors': typeof AppStudioConnectorsRouteWithChildren
  '/studio/endpoints': typeof AppStudioEndpointsRoute
  '/studio/integrations': typeof AppStudioIntegrationsRoute
  '/studio/mcp': typeof AppStudioMcpRoute
  '/studio/models': typeof AppStudioModelsRoute
  '/studio/providers': typeof AppStudioProvidersRoute
  '/studio/schedules': typeof AppStudioSchedulesRoute
  '/studio/skills': typeof AppStudioSkillsRoute
  '/studio/teams': typeof AppStudioTeamsRouteWithChildren
  '/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/tasks/board': typeof AppTasksBoardRoute
  '/workplace/$roomId': typeof AppWorkplaceRoomIdRoute
  '/chat/': typeof AppChatIndexRoute
  '/insights/': typeof AppInsightsIndexRoute
  '/knowledge/': typeof AppKnowledgeIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/studio/': typeof AppStudioIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/workplace/': typeof AppWorkplaceIndexRoute
  '/insights/runs/$runId': typeof AppInsightsRunsRunIdRoute
  '/studio/agents/$agentId': typeof AppStudioAgentsAgentIdRoute
  '/studio/connectors/$connectorId': typeof AppStudioConnectorsConnectorIdRoute
  '/studio/evals/$suiteId': typeof AppStudioEvalsSuiteIdRoute
  '/studio/teams/$teamId': typeof AppStudioTeamsTeamIdRoute
  '/tasks/projects/$projectId': typeof AppTasksProjectsProjectIdRoute
  '/insights/runs/': typeof AppInsightsRunsIndexRoute
  '/studio/agents/': typeof AppStudioAgentsIndexRoute
  '/studio/connectors/': typeof AppStudioConnectorsIndexRoute
  '/studio/evals/': typeof AppStudioEvalsIndexRoute
  '/studio/teams/': typeof AppStudioTeamsIndexRoute
  '/tasks/projects/': typeof AppTasksProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/kit': typeof AppKitRoute
  '/': typeof AppIndexRoute
  '/chat/$sessionId': typeof AppChatSessionIdRoute
  '/chat/history': typeof AppChatHistoryRoute
  '/chat/playground': typeof AppChatPlaygroundRoute
  '/insights/costs': typeof AppInsightsCostsRoute
  '/insights/monitor': typeof AppInsightsMonitorRoute
  '/knowledge/search': typeof AppKnowledgeSearchRoute
  '/settings/api-tokens': typeof AppSettingsApiTokensRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/organization': typeof AppSettingsOrganizationRoute
  '/settings/organizations': typeof AppSettingsOrganizationsRoute
  '/settings/platform-users': typeof AppSettingsPlatformUsersRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/studio/automations': typeof AppStudioAutomationsRoute
  '/studio/budgets': typeof AppStudioBudgetsRoute
  '/studio/endpoints': typeof AppStudioEndpointsRoute
  '/studio/integrations': typeof AppStudioIntegrationsRoute
  '/studio/mcp': typeof AppStudioMcpRoute
  '/studio/models': typeof AppStudioModelsRoute
  '/studio/providers': typeof AppStudioProvidersRoute
  '/studio/schedules': typeof AppStudioSchedulesRoute
  '/studio/skills': typeof AppStudioSkillsRoute
  '/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/tasks/board': typeof AppTasksBoardRoute
  '/workplace/$roomId': typeof AppWorkplaceRoomIdRoute
  '/chat': typeof AppChatIndexRoute
  '/insights': typeof AppInsightsIndexRoute
  '/knowledge': typeof AppKnowledgeIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/studio': typeof AppStudioIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/workplace': typeof AppWorkplaceIndexRoute
  '/insights/runs/$runId': typeof AppInsightsRunsRunIdRoute
  '/studio/agents/$agentId': typeof AppStudioAgentsAgentIdRoute
  '/studio/connectors/$connectorId': typeof AppStudioConnectorsConnectorIdRoute
  '/studio/evals/$suiteId': typeof AppStudioEvalsSuiteIdRoute
  '/studio/teams/$teamId': typeof AppStudioTeamsTeamIdRoute
  '/tasks/projects/$projectId': typeof AppTasksProjectsProjectIdRoute
  '/insights/runs': typeof AppInsightsRunsIndexRoute
  '/studio/agents': typeof AppStudioAgentsIndexRoute
  '/studio/connectors': typeof AppStudioConnectorsIndexRoute
  '/studio/evals': typeof AppStudioEvalsIndexRoute
  '/studio/teams': typeof AppStudioTeamsIndexRoute
  '/tasks/projects': typeof AppTasksProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/chat': typeof AppChatRouteRouteWithChildren
  '/_app/insights': typeof AppInsightsRouteRouteWithChildren
  '/_app/knowledge': typeof AppKnowledgeRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/studio': typeof AppStudioRouteRouteWithChildren
  '/_app/tasks': typeof AppTasksRouteRouteWithChildren
  '/_app/workplace': typeof AppWorkplaceRouteRouteWithChildren
  '/_app/kit': typeof AppKitRoute
  '/_app/': typeof AppIndexRoute
  '/_app/chat/$sessionId': typeof AppChatSessionIdRoute
  '/_app/chat/history': typeof AppChatHistoryRoute
  '/_app/chat/playground': typeof AppChatPlaygroundRoute
  '/_app/insights/costs': typeof AppInsightsCostsRoute
  '/_app/insights/monitor': typeof AppInsightsMonitorRoute
  '/_app/insights/runs': typeof AppInsightsRunsRouteWithChildren
  '/_app/knowledge/search': typeof AppKnowledgeSearchRoute
  '/_app/settings/api-tokens': typeof AppSettingsApiTokensRoute
  '/_app/settings/audit': typeof AppSettingsAuditRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/settings/organization': typeof AppSettingsOrganizationRoute
  '/_app/settings/organizations': typeof AppSettingsOrganizationsRoute
  '/_app/settings/platform-users': typeof AppSettingsPlatformUsersRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/studio/agents': typeof AppStudioAgentsRouteWithChildren
  '/_app/studio/automations': typeof AppStudioAutomationsRoute
  '/_app/studio/budgets': typeof AppStudioBudgetsRoute
  '/_app/studio/connectors': typeof AppStudioConnectorsRouteWithChildren
  '/_app/studio/endpoints': typeof AppStudioEndpointsRoute
  '/_app/studio/integrations': typeof AppStudioIntegrationsRoute
  '/_app/studio/mcp': typeof AppStudioMcpRoute
  '/_app/studio/models': typeof AppStudioModelsRoute
  '/_app/studio/providers': typeof AppStudioProvidersRoute
  '/_app/studio/schedules': typeof AppStudioSchedulesRoute
  '/_app/studio/skills': typeof AppStudioSkillsRoute
  '/_app/studio/teams': typeof AppStudioTeamsRouteWithChildren
  '/_app/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/_app/tasks/board': typeof AppTasksBoardRoute
  '/_app/workplace/$roomId': typeof AppWorkplaceRoomIdRoute
  '/_app/chat/': typeof AppChatIndexRoute
  '/_app/insights/': typeof AppInsightsIndexRoute
  '/_app/knowledge/': typeof AppKnowledgeIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/studio/': typeof AppStudioIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/workplace/': typeof AppWorkplaceIndexRoute
  '/_app/insights/runs/$runId': typeof AppInsightsRunsRunIdRoute
  '/_app/studio/agents/$agentId': typeof AppStudioAgentsAgentIdRoute
  '/_app/studio/connectors/$connectorId': typeof AppStudioConnectorsConnectorIdRoute
  '/_app/studio/evals/$suiteId': typeof AppStudioEvalsSuiteIdRoute
  '/_app/studio/teams/$teamId': typeof AppStudioTeamsTeamIdRoute
  '/_app/tasks/projects/$projectId': typeof AppTasksProjectsProjectIdRoute
  '/_app/insights/runs/': typeof AppInsightsRunsIndexRoute
  '/_app/studio/agents/': typeof AppStudioAgentsIndexRoute
  '/_app/studio/connectors/': typeof AppStudioConnectorsIndexRoute
  '/_app/studio/evals/': typeof AppStudioEvalsIndexRoute
  '/_app/studio/teams/': typeof AppStudioTeamsIndexRoute
  '/_app/tasks/projects/': typeof AppTasksProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/chat'
    | '/insights'
    | '/knowledge'
    | '/settings'
    | '/studio'
    | '/tasks'
    | '/workplace'
    | '/kit'
    | '/chat/$sessionId'
    | '/chat/history'
    | '/chat/playground'
    | '/insights/costs'
    | '/insights/monitor'
    | '/insights/runs'
    | '/knowledge/search'
    | '/settings/api-tokens'
    | '/settings/audit'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/organizations'
    | '/settings/platform-users'
    | '/settings/profile'
    | '/studio/agents'
    | '/studio/automations'
    | '/studio/budgets'
    | '/studio/connectors'
    | '/studio/endpoints'
    | '/studio/integrations'
    | '/studio/mcp'
    | '/studio/models'
    | '/studio/providers'
    | '/studio/schedules'
    | '/studio/skills'
    | '/studio/teams'
    | '/tasks/$taskId'
    | '/tasks/board'
    | '/workplace/$roomId'
    | '/chat/'
    | '/insights/'
    | '/knowledge/'
    | '/settings/'
    | '/studio/'
    | '/tasks/'
    | '/workplace/'
    | '/insights/runs/$runId'
    | '/studio/agents/$agentId'
    | '/studio/connectors/$connectorId'
    | '/studio/evals/$suiteId'
    | '/studio/teams/$teamId'
    | '/tasks/projects/$projectId'
    | '/insights/runs/'
    | '/studio/agents/'
    | '/studio/connectors/'
    | '/studio/evals/'
    | '/studio/teams/'
    | '/tasks/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/kit'
    | '/'
    | '/chat/$sessionId'
    | '/chat/history'
    | '/chat/playground'
    | '/insights/costs'
    | '/insights/monitor'
    | '/knowledge/search'
    | '/settings/api-tokens'
    | '/settings/audit'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/organizations'
    | '/settings/platform-users'
    | '/settings/profile'
    | '/studio/automations'
    | '/studio/budgets'
    | '/studio/endpoints'
    | '/studio/integrations'
    | '/studio/mcp'
    | '/studio/models'
    | '/studio/providers'
    | '/studio/schedules'
    | '/studio/skills'
    | '/tasks/$taskId'
    | '/tasks/board'
    | '/workplace/$roomId'
    | '/chat'
    | '/insights'
    | '/knowledge'
    | '/settings'
    | '/studio'
    | '/tasks'
    | '/workplace'
    | '/insights/runs/$runId'
    | '/studio/agents/$agentId'
    | '/studio/connectors/$connectorId'
    | '/studio/evals/$suiteId'
    | '/studio/teams/$teamId'
    | '/tasks/projects/$projectId'
    | '/insights/runs'
    | '/studio/agents'
    | '/studio/connectors'
    | '/studio/evals'
    | '/studio/teams'
    | '/tasks/projects'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/chat'
    | '/_app/insights'
    | '/_app/knowledge'
    | '/_app/settings'
    | '/_app/studio'
    | '/_app/tasks'
    | '/_app/workplace'
    | '/_app/kit'
    | '/_app/'
    | '/_app/chat/$sessionId'
    | '/_app/chat/history'
    | '/_app/chat/playground'
    | '/_app/insights/costs'
    | '/_app/insights/monitor'
    | '/_app/insights/runs'
    | '/_app/knowledge/search'
    | '/_app/settings/api-tokens'
    | '/_app/settings/audit'
    | '/_app/settings/members'
    | '/_app/settings/organization'
    | '/_app/settings/organizations'
    | '/_app/settings/platform-users'
    | '/_app/settings/profile'
    | '/_app/studio/agents'
    | '/_app/studio/automations'
    | '/_app/studio/budgets'
    | '/_app/studio/connectors'
    | '/_app/studio/endpoints'
    | '/_app/studio/integrations'
    | '/_app/studio/mcp'
    | '/_app/studio/models'
    | '/_app/studio/providers'
    | '/_app/studio/schedules'
    | '/_app/studio/skills'
    | '/_app/studio/teams'
    | '/_app/tasks/$taskId'
    | '/_app/tasks/board'
    | '/_app/workplace/$roomId'
    | '/_app/chat/'
    | '/_app/insights/'
    | '/_app/knowledge/'
    | '/_app/settings/'
    | '/_app/studio/'
    | '/_app/tasks/'
    | '/_app/workplace/'
    | '/_app/insights/runs/$runId'
    | '/_app/studio/agents/$agentId'
    | '/_app/studio/connectors/$connectorId'
    | '/_app/studio/evals/$suiteId'
    | '/_app/studio/teams/$teamId'
    | '/_app/tasks/projects/$projectId'
    | '/_app/insights/runs/'
    | '/_app/studio/agents/'
    | '/_app/studio/connectors/'
    | '/_app/studio/evals/'
    | '/_app/studio/teams/'
    | '/_app/tasks/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kit': {
      id: '/_app/kit'
      path: '/kit'
      fullPath: '/kit'
      preLoaderRoute: typeof AppKitRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge': {
      id: '/_app/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof AppKnowledgeRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/studio': {
      id: '/_app/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof AppStudioRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workplace': {
      id: '/_app/workplace'
      path: '/workplace'
      fullPath: '/workplace'
      preLoaderRoute: typeof AppWorkplaceRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat/': {
      id: '/_app/chat/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof AppChatIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/chat/$sessionId': {
      id: '/_app/chat/$sessionId'
      path: '/$sessionId'
      fullPath: '/chat/$sessionId'
      preLoaderRoute: typeof AppChatSessionIdRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/chat/history': {
      id: '/_app/chat/history'
      path: '/history'
      fullPath: '/chat/history'
      preLoaderRoute: typeof AppChatHistoryRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/chat/playground': {
      id: '/_app/chat/playground'
      path: '/playground'
      fullPath: '/chat/playground'
      preLoaderRoute: typeof AppChatPlaygroundRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/insights/': {
      id: '/_app/insights/'
      path: '/'
      fullPath: '/insights/'
      preLoaderRoute: typeof AppInsightsIndexRouteImport
      parentRoute: typeof AppInsightsRouteRoute
    }
    '/_app/insights/costs': {
      id: '/_app/insights/costs'
      path: '/costs'
      fullPath: '/insights/costs'
      preLoaderRoute: typeof AppInsightsCostsRouteImport
      parentRoute: typeof AppInsightsRouteRoute
    }
    '/_app/insights/monitor': {
      id: '/_app/insights/monitor'
      path: '/monitor'
      fullPath: '/insights/monitor'
      preLoaderRoute: typeof AppInsightsMonitorRouteImport
      parentRoute: typeof AppInsightsRouteRoute
    }
    '/_app/insights/runs': {
      id: '/_app/insights/runs'
      path: '/runs'
      fullPath: '/insights/runs'
      preLoaderRoute: typeof AppInsightsRunsRouteImport
      parentRoute: typeof AppInsightsRouteRoute
    }
    '/_app/knowledge/': {
      id: '/_app/knowledge/'
      path: '/'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof AppKnowledgeIndexRouteImport
      parentRoute: typeof AppKnowledgeRouteRoute
    }
    '/_app/knowledge/search': {
      id: '/_app/knowledge/search'
      path: '/search'
      fullPath: '/knowledge/search'
      preLoaderRoute: typeof AppKnowledgeSearchRouteImport
      parentRoute: typeof AppKnowledgeRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/api-tokens': {
      id: '/_app/settings/api-tokens'
      path: '/api-tokens'
      fullPath: '/settings/api-tokens'
      preLoaderRoute: typeof AppSettingsApiTokensRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/audit': {
      id: '/_app/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof AppSettingsAuditRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/organization': {
      id: '/_app/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AppSettingsOrganizationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/organizations': {
      id: '/_app/settings/organizations'
      path: '/organizations'
      fullPath: '/settings/organizations'
      preLoaderRoute: typeof AppSettingsOrganizationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/platform-users': {
      id: '/_app/settings/platform-users'
      path: '/platform-users'
      fullPath: '/settings/platform-users'
      preLoaderRoute: typeof AppSettingsPlatformUsersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/studio/': {
      id: '/_app/studio/'
      path: '/'
      fullPath: '/studio/'
      preLoaderRoute: typeof AppStudioIndexRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/agents': {
      id: '/_app/studio/agents'
      path: '/agents'
      fullPath: '/studio/agents'
      preLoaderRoute: typeof AppStudioAgentsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/automations': {
      id: '/_app/studio/automations'
      path: '/automations'
      fullPath: '/studio/automations'
      preLoaderRoute: typeof AppStudioAutomationsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/budgets': {
      id: '/_app/studio/budgets'
      path: '/budgets'
      fullPath: '/studio/budgets'
      preLoaderRoute: typeof AppStudioBudgetsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/connectors': {
      id: '/_app/studio/connectors'
      path: '/connectors'
      fullPath: '/studio/connectors'
      preLoaderRoute: typeof AppStudioConnectorsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/endpoints': {
      id: '/_app/studio/endpoints'
      path: '/endpoints'
      fullPath: '/studio/endpoints'
      preLoaderRoute: typeof AppStudioEndpointsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/integrations': {
      id: '/_app/studio/integrations'
      path: '/integrations'
      fullPath: '/studio/integrations'
      preLoaderRoute: typeof AppStudioIntegrationsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/mcp': {
      id: '/_app/studio/mcp'
      path: '/mcp'
      fullPath: '/studio/mcp'
      preLoaderRoute: typeof AppStudioMcpRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/models': {
      id: '/_app/studio/models'
      path: '/models'
      fullPath: '/studio/models'
      preLoaderRoute: typeof AppStudioModelsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/providers': {
      id: '/_app/studio/providers'
      path: '/providers'
      fullPath: '/studio/providers'
      preLoaderRoute: typeof AppStudioProvidersRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/schedules': {
      id: '/_app/studio/schedules'
      path: '/schedules'
      fullPath: '/studio/schedules'
      preLoaderRoute: typeof AppStudioSchedulesRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/skills': {
      id: '/_app/studio/skills'
      path: '/skills'
      fullPath: '/studio/skills'
      preLoaderRoute: typeof AppStudioSkillsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/teams': {
      id: '/_app/studio/teams'
      path: '/teams'
      fullPath: '/studio/teams'
      preLoaderRoute: typeof AppStudioTeamsRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppTasksRouteRoute
    }
    '/_app/tasks/$taskId': {
      id: '/_app/tasks/$taskId'
      path: '/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AppTasksTaskIdRouteImport
      parentRoute: typeof AppTasksRouteRoute
    }
    '/_app/tasks/board': {
      id: '/_app/tasks/board'
      path: '/board'
      fullPath: '/tasks/board'
      preLoaderRoute: typeof AppTasksBoardRouteImport
      parentRoute: typeof AppTasksRouteRoute
    }
    '/_app/workplace/': {
      id: '/_app/workplace/'
      path: '/'
      fullPath: '/workplace/'
      preLoaderRoute: typeof AppWorkplaceIndexRouteImport
      parentRoute: typeof AppWorkplaceRouteRoute
    }
    '/_app/workplace/$roomId': {
      id: '/_app/workplace/$roomId'
      path: '/$roomId'
      fullPath: '/workplace/$roomId'
      preLoaderRoute: typeof AppWorkplaceRoomIdRouteImport
      parentRoute: typeof AppWorkplaceRouteRoute
    }
    '/_app/insights/runs/': {
      id: '/_app/insights/runs/'
      path: '/'
      fullPath: '/insights/runs/'
      preLoaderRoute: typeof AppInsightsRunsIndexRouteImport
      parentRoute: typeof AppInsightsRunsRoute
    }
    '/_app/insights/runs/$runId': {
      id: '/_app/insights/runs/$runId'
      path: '/$runId'
      fullPath: '/insights/runs/$runId'
      preLoaderRoute: typeof AppInsightsRunsRunIdRouteImport
      parentRoute: typeof AppInsightsRunsRoute
    }
    '/_app/studio/agents/': {
      id: '/_app/studio/agents/'
      path: '/'
      fullPath: '/studio/agents/'
      preLoaderRoute: typeof AppStudioAgentsIndexRouteImport
      parentRoute: typeof AppStudioAgentsRoute
    }
    '/_app/studio/agents/$agentId': {
      id: '/_app/studio/agents/$agentId'
      path: '/$agentId'
      fullPath: '/studio/agents/$agentId'
      preLoaderRoute: typeof AppStudioAgentsAgentIdRouteImport
      parentRoute: typeof AppStudioAgentsRoute
    }
    '/_app/studio/connectors/': {
      id: '/_app/studio/connectors/'
      path: '/'
      fullPath: '/studio/connectors/'
      preLoaderRoute: typeof AppStudioConnectorsIndexRouteImport
      parentRoute: typeof AppStudioConnectorsRoute
    }
    '/_app/studio/connectors/$connectorId': {
      id: '/_app/studio/connectors/$connectorId'
      path: '/$connectorId'
      fullPath: '/studio/connectors/$connectorId'
      preLoaderRoute: typeof AppStudioConnectorsConnectorIdRouteImport
      parentRoute: typeof AppStudioConnectorsRoute
    }
    '/_app/studio/evals/': {
      id: '/_app/studio/evals/'
      path: '/evals'
      fullPath: '/studio/evals/'
      preLoaderRoute: typeof AppStudioEvalsIndexRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/evals/$suiteId': {
      id: '/_app/studio/evals/$suiteId'
      path: '/evals/$suiteId'
      fullPath: '/studio/evals/$suiteId'
      preLoaderRoute: typeof AppStudioEvalsSuiteIdRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/teams/': {
      id: '/_app/studio/teams/'
      path: '/'
      fullPath: '/studio/teams/'
      preLoaderRoute: typeof AppStudioTeamsIndexRouteImport
      parentRoute: typeof AppStudioTeamsRoute
    }
    '/_app/studio/teams/$teamId': {
      id: '/_app/studio/teams/$teamId'
      path: '/$teamId'
      fullPath: '/studio/teams/$teamId'
      preLoaderRoute: typeof AppStudioTeamsTeamIdRouteImport
      parentRoute: typeof AppStudioTeamsRoute
    }
    '/_app/tasks/projects/': {
      id: '/_app/tasks/projects/'
      path: '/projects'
      fullPath: '/tasks/projects/'
      preLoaderRoute: typeof AppTasksProjectsIndexRouteImport
      parentRoute: typeof AppTasksRouteRoute
    }
    '/_app/tasks/projects/$projectId': {
      id: '/_app/tasks/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/tasks/projects/$projectId'
      preLoaderRoute: typeof AppTasksProjectsProjectIdRouteImport
      parentRoute: typeof AppTasksRouteRoute
    }
  }
}

interface AppChatRouteRouteChildren {
  AppChatSessionIdRoute: typeof AppChatSessionIdRoute
  AppChatHistoryRoute: typeof AppChatHistoryRoute
  AppChatPlaygroundRoute: typeof AppChatPlaygroundRoute
  AppChatIndexRoute: typeof AppChatIndexRoute
}

const AppChatRouteRouteChildren: AppChatRouteRouteChildren = {
  AppChatSessionIdRoute: AppChatSessionIdRoute,
  AppChatHistoryRoute: AppChatHistoryRoute,
  AppChatPlaygroundRoute: AppChatPlaygroundRoute,
  AppChatIndexRoute: AppChatIndexRoute,
}

const AppChatRouteRouteWithChildren = AppChatRouteRoute._addFileChildren(
  AppChatRouteRouteChildren,
)

interface AppInsightsRunsRouteChildren {
  AppInsightsRunsRunIdRoute: typeof AppInsightsRunsRunIdRoute
  AppInsightsRunsIndexRoute: typeof AppInsightsRunsIndexRoute
}

const AppInsightsRunsRouteChildren: AppInsightsRunsRouteChildren = {
  AppInsightsRunsRunIdRoute: AppInsightsRunsRunIdRoute,
  AppInsightsRunsIndexRoute: AppInsightsRunsIndexRoute,
}

const AppInsightsRunsRouteWithChildren = AppInsightsRunsRoute._addFileChildren(
  AppInsightsRunsRouteChildren,
)

interface AppInsightsRouteRouteChildren {
  AppInsightsCostsRoute: typeof AppInsightsCostsRoute
  AppInsightsMonitorRoute: typeof AppInsightsMonitorRoute
  AppInsightsRunsRoute: typeof AppInsightsRunsRouteWithChildren
  AppInsightsIndexRoute: typeof AppInsightsIndexRoute
}

const AppInsightsRouteRouteChildren: AppInsightsRouteRouteChildren = {
  AppInsightsCostsRoute: AppInsightsCostsRoute,
  AppInsightsMonitorRoute: AppInsightsMonitorRoute,
  AppInsightsRunsRoute: AppInsightsRunsRouteWithChildren,
  AppInsightsIndexRoute: AppInsightsIndexRoute,
}

const AppInsightsRouteRouteWithChildren =
  AppInsightsRouteRoute._addFileChildren(AppInsightsRouteRouteChildren)

interface AppKnowledgeRouteRouteChildren {
  AppKnowledgeSearchRoute: typeof AppKnowledgeSearchRoute
  AppKnowledgeIndexRoute: typeof AppKnowledgeIndexRoute
}

const AppKnowledgeRouteRouteChildren: AppKnowledgeRouteRouteChildren = {
  AppKnowledgeSearchRoute: AppKnowledgeSearchRoute,
  AppKnowledgeIndexRoute: AppKnowledgeIndexRoute,
}

const AppKnowledgeRouteRouteWithChildren =
  AppKnowledgeRouteRoute._addFileChildren(AppKnowledgeRouteRouteChildren)

interface AppSettingsRouteRouteChildren {
  AppSettingsApiTokensRoute: typeof AppSettingsApiTokensRoute
  AppSettingsAuditRoute: typeof AppSettingsAuditRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsOrganizationRoute: typeof AppSettingsOrganizationRoute
  AppSettingsOrganizationsRoute: typeof AppSettingsOrganizationsRoute
  AppSettingsPlatformUsersRoute: typeof AppSettingsPlatformUsersRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsApiTokensRoute: AppSettingsApiTokensRoute,
  AppSettingsAuditRoute: AppSettingsAuditRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsOrganizationRoute: AppSettingsOrganizationRoute,
  AppSettingsOrganizationsRoute: AppSettingsOrganizationsRoute,
  AppSettingsPlatformUsersRoute: AppSettingsPlatformUsersRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppStudioAgentsRouteChildren {
  AppStudioAgentsAgentIdRoute: typeof AppStudioAgentsAgentIdRoute
  AppStudioAgentsIndexRoute: typeof AppStudioAgentsIndexRoute
}

const AppStudioAgentsRouteChildren: AppStudioAgentsRouteChildren = {
  AppStudioAgentsAgentIdRoute: AppStudioAgentsAgentIdRoute,
  AppStudioAgentsIndexRoute: AppStudioAgentsIndexRoute,
}

const AppStudioAgentsRouteWithChildren = AppStudioAgentsRoute._addFileChildren(
  AppStudioAgentsRouteChildren,
)

interface AppStudioConnectorsRouteChildren {
  AppStudioConnectorsConnectorIdRoute: typeof AppStudioConnectorsConnectorIdRoute
  AppStudioConnectorsIndexRoute: typeof AppStudioConnectorsIndexRoute
}

const AppStudioConnectorsRouteChildren: AppStudioConnectorsRouteChildren = {
  AppStudioConnectorsConnectorIdRoute: AppStudioConnectorsConnectorIdRoute,
  AppStudioConnectorsIndexRoute: AppStudioConnectorsIndexRoute,
}

const AppStudioConnectorsRouteWithChildren =
  AppStudioConnectorsRoute._addFileChildren(AppStudioConnectorsRouteChildren)

interface AppStudioTeamsRouteChildren {
  AppStudioTeamsTeamIdRoute: typeof AppStudioTeamsTeamIdRoute
  AppStudioTeamsIndexRoute: typeof AppStudioTeamsIndexRoute
}

const AppStudioTeamsRouteChildren: AppStudioTeamsRouteChildren = {
  AppStudioTeamsTeamIdRoute: AppStudioTeamsTeamIdRoute,
  AppStudioTeamsIndexRoute: AppStudioTeamsIndexRoute,
}

const AppStudioTeamsRouteWithChildren = AppStudioTeamsRoute._addFileChildren(
  AppStudioTeamsRouteChildren,
)

interface AppStudioRouteRouteChildren {
  AppStudioAgentsRoute: typeof AppStudioAgentsRouteWithChildren
  AppStudioAutomationsRoute: typeof AppStudioAutomationsRoute
  AppStudioBudgetsRoute: typeof AppStudioBudgetsRoute
  AppStudioConnectorsRoute: typeof AppStudioConnectorsRouteWithChildren
  AppStudioEndpointsRoute: typeof AppStudioEndpointsRoute
  AppStudioIntegrationsRoute: typeof AppStudioIntegrationsRoute
  AppStudioMcpRoute: typeof AppStudioMcpRoute
  AppStudioModelsRoute: typeof AppStudioModelsRoute
  AppStudioProvidersRoute: typeof AppStudioProvidersRoute
  AppStudioSchedulesRoute: typeof AppStudioSchedulesRoute
  AppStudioSkillsRoute: typeof AppStudioSkillsRoute
  AppStudioTeamsRoute: typeof AppStudioTeamsRouteWithChildren
  AppStudioIndexRoute: typeof AppStudioIndexRoute
  AppStudioEvalsSuiteIdRoute: typeof AppStudioEvalsSuiteIdRoute
  AppStudioEvalsIndexRoute: typeof AppStudioEvalsIndexRoute
}

const AppStudioRouteRouteChildren: AppStudioRouteRouteChildren = {
  AppStudioAgentsRoute: AppStudioAgentsRouteWithChildren,
  AppStudioAutomationsRoute: AppStudioAutomationsRoute,
  AppStudioBudgetsRoute: AppStudioBudgetsRoute,
  AppStudioConnectorsRoute: AppStudioConnectorsRouteWithChildren,
  AppStudioEndpointsRoute: AppStudioEndpointsRoute,
  AppStudioIntegrationsRoute: AppStudioIntegrationsRoute,
  AppStudioMcpRoute: AppStudioMcpRoute,
  AppStudioModelsRoute: AppStudioModelsRoute,
  AppStudioProvidersRoute: AppStudioProvidersRoute,
  AppStudioSchedulesRoute: AppStudioSchedulesRoute,
  AppStudioSkillsRoute: AppStudioSkillsRoute,
  AppStudioTeamsRoute: AppStudioTeamsRouteWithChildren,
  AppStudioIndexRoute: AppStudioIndexRoute,
  AppStudioEvalsSuiteIdRoute: AppStudioEvalsSuiteIdRoute,
  AppStudioEvalsIndexRoute: AppStudioEvalsIndexRoute,
}

const AppStudioRouteRouteWithChildren = AppStudioRouteRoute._addFileChildren(
  AppStudioRouteRouteChildren,
)

interface AppTasksRouteRouteChildren {
  AppTasksTaskIdRoute: typeof AppTasksTaskIdRoute
  AppTasksBoardRoute: typeof AppTasksBoardRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
  AppTasksProjectsProjectIdRoute: typeof AppTasksProjectsProjectIdRoute
  AppTasksProjectsIndexRoute: typeof AppTasksProjectsIndexRoute
}

const AppTasksRouteRouteChildren: AppTasksRouteRouteChildren = {
  AppTasksTaskIdRoute: AppTasksTaskIdRoute,
  AppTasksBoardRoute: AppTasksBoardRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
  AppTasksProjectsProjectIdRoute: AppTasksProjectsProjectIdRoute,
  AppTasksProjectsIndexRoute: AppTasksProjectsIndexRoute,
}

const AppTasksRouteRouteWithChildren = AppTasksRouteRoute._addFileChildren(
  AppTasksRouteRouteChildren,
)

interface AppWorkplaceRouteRouteChildren {
  AppWorkplaceRoomIdRoute: typeof AppWorkplaceRoomIdRoute
  AppWorkplaceIndexRoute: typeof AppWorkplaceIndexRoute
}

const AppWorkplaceRouteRouteChildren: AppWorkplaceRouteRouteChildren = {
  AppWorkplaceRoomIdRoute: AppWorkplaceRoomIdRoute,
  AppWorkplaceIndexRoute: AppWorkplaceIndexRoute,
}

const AppWorkplaceRouteRouteWithChildren =
  AppWorkplaceRouteRoute._addFileChildren(AppWorkplaceRouteRouteChildren)

interface AppRouteChildren {
  AppChatRouteRoute: typeof AppChatRouteRouteWithChildren
  AppInsightsRouteRoute: typeof AppInsightsRouteRouteWithChildren
  AppKnowledgeRouteRoute: typeof AppKnowledgeRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppStudioRouteRoute: typeof AppStudioRouteRouteWithChildren
  AppTasksRouteRoute: typeof AppTasksRouteRouteWithChildren
  AppWorkplaceRouteRoute: typeof AppWorkplaceRouteRouteWithChildren
  AppKitRoute: typeof AppKitRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChatRouteRoute: AppChatRouteRouteWithChildren,
  AppInsightsRouteRoute: AppInsightsRouteRouteWithChildren,
  AppKnowledgeRouteRoute: AppKnowledgeRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppStudioRouteRoute: AppStudioRouteRouteWithChildren,
  AppTasksRouteRoute: AppTasksRouteRouteWithChildren,
  AppWorkplaceRouteRoute: AppWorkplaceRouteRouteWithChildren,
  AppKitRoute: AppKitRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
